import { render, staticRenderFns } from "./PlusOrga.vue?vue&type=template&id=d11246e0&scoped=true"
import script from "./PlusOrga.vue?vue&type=script&lang=js"
export * from "./PlusOrga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d11246e0",
  null
  
)

export default component.exports